import { Disclaimer } from '@3ddv/ngx-sites-builder-lib';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DisclaimerService {
  public tempFile: File;

  constructor() {}

  public saveTempFile(file) {
    this.tempFile = file;
  }

  public getTempFile() {
    return this.tempFile;
  }

  // Adds or overwrites customData to tool.data
  public addCustomData(tool: Disclaimer) {
    // console.log('tool (service)', tool);

    if (tool.data) {
      // To update view list
      tool.data = JSON.parse(JSON.stringify(tool.data));
    } else {
      tool.data = {};
    }

    // Check and add/overwrites data
    for (const key in tool.customData) {
      tool.data[key] = tool.customData[key];
    }

    // Si el objeto customData está vacío
    if (tool.customData && Object.keys(tool.customData).length === 0) {
      tool.customData = null;
    }
    // Si el objeto data está vacío
    if (tool.data && Object.keys(tool.data).length === 0) {
      tool.data = null;
    }

    return tool;
  }
}
